import $ from "jquery";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
// You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/

$(function() {
  
  if (($('#controller-registrations').length === 0) && ($('#controller-invitations').length === 0)) { return; }
  
  return $('#new_user, #edit_user').find('input[type=text], input[type=email], input[type=password]').focus(function() {
    return $(this).parent().removeClass('field_with_errors');
  });
});
